import { Outlet } from '@remix-run/react';
import { Toaster } from '~/components/Toaster';

export default function AuthLayout() {
  return (
    <div className="p-12 grid place-content-center h-svh">
      <Outlet />
      <Toaster />
    </div>
  );
}
